import { useContext, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from './userContext';
import { getToken, getSessionData, clearSession } from './sessionManager';

const PROTECTED_ROUTES = ['/ajoutAnnonce', '/showAnnonce', '/showStatistique', '/showPayment', '/showGoChat', '/chat'];

function useUserSession() {
  const { user, setUser, loading, setLoading, nbnotif, setNbnotif } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        // Utilisateur Firebase connecté
      } else {
        // Pas de session Firebase, vérifier le token local
        const sessionData = getSessionData();
        if (sessionData) {
          setUser(sessionData);
        } else {
          setUser(null);
        }
      }
    });

    return () => unsubscribe();
  }, [setUser]);

  // Redirige si le token est invalide/expiré sur les routes protégées
  useEffect(() => {
    const token = getToken();
    const isProtectedRoute = PROTECTED_ROUTES.some(route => location.pathname.startsWith(route));
    if (!loading && !token && isProtectedRoute) {
      clearSession();
      setUser(null);
      navigate('/');
    }
  }, [loading, user, location, navigate, setUser]);

  return { user, loading, setUser, nbnotif, setNbnotif, setLoading };
}

export default useUserSession;